<template>
    <div class="form-group">
        <label :for="id">{{ label }}<span v-if="required" class="text-danger">*</span></label>
        <b-form-textarea :id="id" :value="modelValue" @input="onInput"
            :class="validation && validation.length > 0 ? 'is-invalid' : ''" :placeholder="placeholder" :rows="rows" />
        <small v-if="validation && validation.length > 0" class="text-danger">
            {{ validation.join(', ') }}
        </small>
    </div>
</template>

<script>
import {
    BFormTextarea,
} from 'bootstrap-vue'

export default {
    components: {
        BFormTextarea,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
        },
        validation: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: [String, Number],
        },
    },
    methods: {
        onInput(e) {
            this.$emit("input", e)
        }
    },
};
</script>
